<template>
  <div class="login-form-home unsubscribe-page text-align-left">
    <div class="login-form-wrapper">
      <div class="bp-logo">
          <img src="@/assets/images/logos/BP.png" alt="bp logo">
          <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
          <div class="logo-text">{{ $t('OUTER_PAGES.common.subheading')}}</div>
      </div>

      <div class="wrong-page" v-if="error">
        {{ $t('OUTER_PAGES.common.otherErorr')}}
      </div>

      <div class="back-section">
        <p v-if="pageLoaded && !error">
         {{ $t('OUTER_PAGES.unsubscribeWeekly.success')}}
        </p>

        <router-link class="link underline" :to="{ name: 'Dashboard' }">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          {{ $t('OUTER_PAGES.common.goBack')}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import * as actions from '@/store/action.types'
import { TOASTER_ERROR, TOASTER_SUCCESS } from '@/common/events.types'
import { mapActions } from 'vuex'

export default {
  name: 'UnsubscribeWeekly',
  data () {
    return {
      pageLoaded: false,
      error: false
    }
  },
  computed: {
    token: {
      get () {
        return this.$route.params.token
      }
    }
  },
  mounted () {
    this.unsubscribeAction({ token: this.token, subscribed: false })
      .then(() => {
        this.pageLoaded = true
        this.$eventHub.$emit(TOASTER_SUCCESS, { message: this.$t('OUTER_PAGES.unsubscribeWeekly.toastMessage') })
      })
      .catch(() => {
        this.error = true
        this.pageLoaded = true
        this.$eventHub.$emit(TOASTER_ERROR, { message: this.$t('TOAST_MESSAGES.errorTryAgain') })
      })
  },
  methods: {
    ...mapActions({
      unsubscribeAction: actions.UNSUBSCRIBE_EMAIL_BY_TOKEN
    })
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/views/_unsubscribe.scss';
</style>
